module.exports = __webpack_public_path__ + "img/planta_03.072157b0.jpeg";